var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoItsIcon4(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.206,
    height: 70.203,
    viewBox: "0 0 70.206 70.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 70.206,
    height: 70.203,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13670",
    "data-name": "Path 13670",
    d: "M65.329,60.337a24.549,24.549,0,0,0-9.613-37.077A28.064,28.064,0,1,0,5.943,45.336l-4.88,4.841a3.473,3.473,0,0,0-.748,3.817A3.5,3.5,0,0,0,3.547,56.17H23.5A24.6,24.6,0,0,0,45.649,70.2H66.7a3.52,3.52,0,0,0,2.483-5.993ZM21.089,45.645a22.806,22.806,0,0,0,.276,3.508H12.01l1.221-1.188a3.5,3.5,0,0,0,0-4.987A21.038,21.038,0,0,1,28.107,7.051,20.843,20.843,0,0,1,47.932,21.085H45.649A24.568,24.568,0,0,0,21.089,45.645M58.073,63.187l.163.182H45.649a17.559,17.559,0,1,1,12.424-5.136,3.606,3.606,0,0,0-1.057,2.47,3.481,3.481,0,0,0,1.057,2.484",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoItsIcon4);
export default __webpack_public_path__ + "static/media/who-its-icon4.d4c1d97916e3e1f92c61b48cc046b510.svg";
export { ForwardRef as ReactComponent };